import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Header, Sidebar, ListaVagas } from 'components';

const HomePage = () => {
  return (
    <>
      <Header />
      <Container className="pt-5">
        <Row>
          <Col md={4}>
            <Sidebar />
          </Col>
          <Col>
            <ListaVagas />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default HomePage;
